<template>
    <div>
        <div class="collapsible" :class="{opened: !submitting && !submitted}">
            <Alert :alert="alert"/>

            <ProductVariationsOld
                :product="product"
                v-model="sizeToWish"
                label="Selecione o tamanho que deseja adicionar em sua wishlist:"
                :wishlist-mode="true"/>

            <button @click="submit" class="btn btn-wide mt" :disabled="!sizeToWish">Adicionar</button>
        </div>

        <div class="collapsible" :class="{opened: submitting}">
            <div class="d-flex flex-spaced-fixed">
                <div class="cr-spinner-small"></div>
                <p>Aguarde...</p>
            </div>
        </div>

        <div class="collapsible" :class="{opened: submitted}">
            <div class="alert-success mb">
                <p>
                    Produto adicionado com sucesso. <strong><a href="/minha-conta/wishlist">Clique aqui</a></strong>
                    para ver os produtos da sua wishlist.
                </p>
                <p v-if="showStockWarning">
                    Assim que o produto estiver disponível novamente em estoque te avisaremos por email! :)
                </p>
            </div>

            <button @click="$emit('done')" class="btn btn-wide">Ok</button>
        </div>
    </div>
</template>

<script>
    import {customerService} from "../../../common/resource";
    import ProductVariationsOld from "./ProductVariationsOld";
    import Alert from "../common/Alert";
    import {productStore} from "../../common/store/product-store";

    export default {
        name: "ProductWishlist",

        components: {Alert, ProductVariationsOld},

        data() {
            return {
                productStoreState: productStore.state,

                submitting: false,
                submitted: false,

                alert: null,

                showStockWarning: false,
            }
        },

        mounted() {
            // se o produto contém um único tamanho, já adiciona à wishlist
            if (this.product.variations.length === 1) {
                this.sizeToWish = this.product.variations[0];
                this.submit();
            }
        },

        computed: {
            product() {
                return this.productStoreState.product;
            },

            sizeToWish: {
                get() {
                    return this.productStoreState.sizeToWish
                },

                set(val) {
                    this.productStoreState.sizeToWish = val
                }
            },
        },

        methods: {
            submit() {
                this.submitting = true;
                customerService.addWishlistProduct(this.$scope.id, {
                    product_id: this.product.id,
                    variation_id: this.sizeToWish.variation_id,
                }).then(() => {
                    window.dataLayer.push({
                        event: 'addToWishlist',
                        product_gender: this.sizeToWish.gender,
                        product_size: this.sizeToWish.size_name
                    });

                    this.submitted = true;
                }).catch(response => {
                    this.alert = {
                        message: response.response.data.message || 'Não foi possível adicionar à Wishlist',
                        isError: true
                    }
                }).then(() => this.submitting = false)
            }
        }
    }
</script>